<template lang="html">
  <LoadingIndicator :height="height" :class="liClass"/>
</template>

<script lang="ts" setup>
import LoadingIndicator from "@/components/loaders/LoadingIndicator.vue";
import {computed} from "vue";

const props = defineProps({
  height: {
    type: String,
    default: '60px'
  },
  alignCenter: {
    default: true,
    type: Boolean
  }
})

const liClass = computed(() => {
  return props.alignCenter ? ['li--align-center'] : [];
})
</script>

<style scoped lang="less">
.li--align-center {
  margin: 0 auto;
}
</style>
